export default __webpack_public_path__ + "static/media/za.0d4e849c.svg";